import { ScopedTrackingPermissionChecker } from "./ScopedTrackingPermissionChecker";
import { TrackingPermissionChecker } from "./TrackingPermissionChecker";
import { TrackingScope } from "./TrackingScope";

export class DefaultScopedTrackingPermissionChecker
	implements ScopedTrackingPermissionChecker
{
	constructor(
		private readonly trackingPermissionCheckerByScopeMap: Record<
			TrackingScope,
			TrackingPermissionChecker
		>
	) {
		// do nothing
	}

	isTrackingEnabled(scope: TrackingScope): boolean {
		return this.trackingPermissionCheckerByScopeMap[scope].isTrackingEnabled();
	}
}
